import { Component, OnInit } from '@angular/core';
import { Student } from 'src/app/_models/student';
import { GatePass } from '../../../_models/gate_pass';
import { Guardian } from './../../../_models/guardian';
import { AuthService } from './../../../_services/auth.service';
import { GuardianService } from './../../../_services/guardian.service';
import { StudentService } from './../../../_services/student.service';

@Component({
  selector: 'app-side-bar-nav',
  templateUrl: './side-bar-nav.component.html',
  styleUrls: ['./side-bar-nav.component.css']
})
export class SideBarNavComponent implements OnInit {
  student = new Student()
  guardian = new Guardian()
  gatePass:GatePass = new GatePass()

  home_link:any=undefined

  constructor(
    public authService:AuthService,
    private guardianService:GuardianService,
    private studentService:StudentService) { }

  ngOnInit(): void {

        console.log({yesYesMobile: this.gatePass.is_logged_in})
        this.updateAccessModal()
        this.initGuardianSubject()
        this.initStudentSubject()


        if(this.gatePass.is_logged_in){
          this.home_link= this.authService.processHomeRoute(this.gatePass)
        }else{
          this.home_link=['/']
        }


    }

   initGuardianSubject(){
    this.guardianService.guardianSubject.subscribe(
      x=>{
        this.guardian=x
      }
    )
   }
   initStudentSubject(){
    this.studentService.studentSubject.subscribe(
      x=>{
        this.student=x
      }
    )
   }
   updateAccessModal(){

    this.authService.gatePass.subscribe(
      gatePass=>{this.gatePass=gatePass}
    )
   }


}
